export default {
      id: "ic_soccer-usage",
      viewBox: "0 0 18 18",
      url: "/" + "images/icons.3.109.2.svg#ic_soccer-usage",
      toString: function () {
        return this.url;
      }
    }